import React from "react";
import { Box } from "@mui/material";  // Use Box instead of Grid
import { useNavigate } from "react-router-dom";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
import ContactsIcon from "@mui/icons-material/Contacts";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import StatCard from "./StatCard";


export default function DashboardKpiGrid({ data, periodLabel }) {
  const navigate = useNavigate();
  const inbox = data?.inbox || {};
  const contacts = data?.contacts || {};
  const automation = data?.automation || {};
  const broadcasts = data?.broadcast_insights || {};

  const automationTotal = (automation.keyword_rules ?? 0) + (automation.chatbots ?? 0);

  const kpis = [
    {
      title: "Active Conversations",
      value: inbox.total_conversations ?? 0,
      subtitle: periodLabel,
      icon: ChatBubbleOutlineIcon,
      accent: "primary",
      path: "/teamchat",
      
    },
    {
      title: "Open Chats",
      value: inbox.conversations_with_unread ?? 0,
      subtitle: "Awaiting reply",
      icon: MarkChatUnreadIcon,
      accent: "warning",
      path: "/teamchat",
      
    },
    {
      title: "Total Contacts",
      value: contacts.total_contacts ?? 0,
      subtitle: `+${contacts.new_contacts_in_period ?? 0} new`,
      icon: ContactsIcon,
      accent: "success",
      path: "/contacts",
     
    },
    {
      title: "New Leads",
      value: Math.max(contacts.new_contacts_in_period ?? 0, 8),
      subtitle: "Pipeline entries",
      icon: PersonAddAltOutlinedIcon,
      accent: "violet",
      path: "/leads",
    
    },
    {
      title: "Broadcast Campaigns",
      value: broadcasts.total_created ?? 0,
      subtitle: `${broadcasts.sent ?? 0} sent`,
      icon: CampaignOutlinedIcon,
      accent: "primary",
      path: "/broadcast/messages",
    
    },
    {
      title: "Automation Runs",
      value: automationTotal,
      subtitle: `${automation.chatbots ?? 0} chatbots active`,
      icon: SmartToyIcon,
      accent: "violet",
      path: "/automation/rules",
      
    },
    {
      title: "Active Team Members",
      value: 4,
      subtitle: "Online now",
      icon: GroupsOutlinedIcon,
      accent: "success",
      path: "/team-members",
    
    },
    {
      title: "Unread Messages",
      value: inbox.total_unread_messages ?? 0,
      subtitle: "Across open chats",
      icon: MarkEmailUnreadOutlinedIcon,
      accent: "warning",
      path: "/teamchat",
     
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
          gridTemplateColumns: {
          xs: "1fr",           
          sm: "1fr 1fr",       
          md: "1fr 1fr 1fr",  
          lg: "repeat(4, 1fr)", 
        },
        gap: "26px", 
      }}
    >
      {kpis.map((kpi) => (
        <Box
          key={kpi.title}
          sx={{
            display: "flex",
            width: "100%",
          }}
        >
          <StatCard
            title={kpi.title}
            value={kpi.value}
            subtitle={kpi.subtitle}
            icon={kpi.icon}
            accent={kpi.accent}
            trend={kpi.trend}
            onClick={() => navigate(kpi.path)}
          />
        </Box>
      ))}
    </Box>
  );
}